module.exports = __webpack_public_path__ + "img/Truck3.dda21824.jpg";